import * as React from 'react';
import { ToggleButtons } from 'library';
import { useHistory } from 'react-router';

export default function SignUpLoginTab() {
    const history = useHistory();

    const selectedTab = window.location.pathname.toLocaleLowerCase().indexOf('login') > -1 ? 'Login' : 'Sign Up';

    function onClick(tab: string) {
        if (tab === 'Login') {
            history.push('/login');
            return;
        }

        history.push('/signup');
    }
    return <ToggleButtons tabs={['Login', 'Sign Up']} onTabSelect={onClick} selectedTab={selectedTab} height={40} />;
}
